import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import { Button, Grid, TextField, Typography } from "@mui/material";
import axios from "axios";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Moment from "moment";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";

const AffidavitForm = (props) => {
  const {
    FormId,
    PatientId,
    PatientName,
    onFormSubmit,
    handleClose,
    PatientDob,
  } = props;
  const [signatureDate, setSignatureDate] = useState(null);
  const [physicianDate, setphysicianDate] = useState(
    Moment().format("YYYY-MM-DD"),
  );
  const [PatientDobs, setPatientDob] = useState(
    Moment(PatientDob).format("DD-MM-YYYY"),
  );

  const fields = [
    "id",
    "patientId",
    "practiceId",
    "claustrophobiaAnxiety",
    "hasAttemptedCPAPTherapy",
    "basicFollowingReason",
    "pressureIntolerance",
    "insomnia",
    "nonAdherence",
    "nasalObstruction",
    "sinusComplications",
    "skinIssues",
    "aerophagia",
    "cognitiveImpairment",
    "cpapIneffective",
    "other_CPAP",
    "panicDisorder",
    "craniofacialAbnormality",
    "chronicNasalObstruction",
    "latexAllergy_NoCPAP_New",
    "claustrophobia_NoCPAP_New",
    "severeNasalObstruction",
    "neurologicImpairment",
    "priorDocumentedIntolerance",
    "other_NoCPAP",
    "patientSignature",
    "physicianName",
    "physicianDate",
    "physicianSignature",
    "signatureDate",
    "createdDate",
    "createdBy",
    "updatedDate",
    "updatedBy",
    "inactive",
  ];

  const defValues = {
    id: 0,
    patientId: 0,
    practiceId: 0,
    claustrophobiaAnxiety: null,
    hasAttemptedCPAPTherapy: null,
    basicFollowingReason: null,
    pressureIntolerance: null,
    insomnia: null,
    nonAdherence: null,
    nasalObstruction: null,
    sinusComplications: null,
    skinIssues: null,
    aerophagia: null,
    cognitiveImpairment: null,
    cpapIneffective: null,
    other_CPAP: "",
    panicDisorder: null,
    craniofacialAbnormality: null,
    latexAllergy_NoCPAP_New: null,
    claustrophobia_NoCPAP_New: null,
    severeNasalObstruction: null,
    neurologicImpairment: null,
    chronicNasalObstruction: null,
    priorDocumentedIntolerance: null,
    other_NoCPAP: "",
    patientSignature: "",
    physicianSignature: "",
    physicianDate: "",
    physicianName: "",
    signatureDate: "",
    createdDate: "",
    createdBy: "",
    updatedDate: "",
    updatedBy: "",
    inactive: false,
  };

  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = { Authorization: auth };

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: defValues,
  });

  const [submitting, setSubmitting] = useState(false);

  // Load form data if editing
  useEffect(() => {
    if (FormId) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/PatientForms/GetFormAffidavitId?id=${FormId}`,
          { headers },
        )
        .then((response) => {
          fields.forEach((field) => {
            if (response[field] !== undefined) {
              setValue(field, response[field]);
            }
          });

          if (response.signatureDate) {
            setSignatureDate(
              Moment(response.signatureDate).format("YYYY-MM-DD"),
            );
            if (response.physicianDate) {
              setphysicianDate(
                Moment(response.physicianDate).format("YYYY-MM-DD"),
              );
            }
          }
        })
        .catch((error) => {
          console.error("Error loading form data:", error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to load form data",
          });
        });
    }
  }, [FormId]);

  const onSubmit = (data) => {
    setSubmitting(true);

    const postData = {
      ...data,
      patientId: PatientId,
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/PatientForms/AddFormAffidavit`,
        postData,
        { headers },
      )
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Form Added!",
          html: `<p>Affidavit for Intolerance to CPAP Device has been saved successfully.</p>`,
          timer: 2000, // 2 seconds
          showConfirmButton: false,
          timerProgressBar: true,
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) swalPopup.style.zIndex = 2200;
          },
        });

        if (onFormSubmit) {
          onFormSubmit(response.id);
        }

        if (handleClose) {
          handleClose();
        }
        setSubmitting(false);
      })
      .catch((error) => {
        setSubmitting(false);
        Swal.fire({
          icon: "error",
          title: "Failed!",
          html: `<p>${
            error.response?.data?.message ||
            "Something went wrong. Please try again."
          }</p>`,
          confirmButtonColor: "#F44336",
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) swalPopup.style.zIndex = 2200;
          },
        });
      });
  };

  return (
  <Container maxWidth="lg">
  <Grid
    container
    spacing={3}
    justifyContent="center"
    alignItems="center"
    sx={{
      p: 2,
      mb: 2,
    }}
  >
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* Patient Information */}
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography
              variant="h4"
              align="center"
              fontWeight="bold"
              color="primary"
              gutterBottom
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                width: "100%",
                color: "#000", // black color
                textDecoration: "underline", // underline
              }}
            >
              {/* AFFIDAVIT FOR INTOLERANCE TO CPAP DEVICE
               */}
              CPAP Intolerance Documentation Form (For E0486 Oral Appliance
              Medical Necessity)
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          sx={{ m: 2, p: 2, backgroundColor: "#f8f9fa", borderRadius: 2 }}
        >
          {/* <Grid item xs={12} md={6}>
            <Typography variant="body1" fontWeight="medium" gutterBottom>
              Patient Name:
            </Typography>

            <TextField
              size="small"
              fullWidth
              variant="standard"
              InputProps={{
                readOnly: true,
                disableUnderline: false, // underline ON
              }}
              value={PatientName || ""}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="body1" fontWeight="medium" gutterBottom>
              Patient DOB:
            </Typography>

            <TextField
              size="small"
              fullWidth
              variant="standard"
              InputProps={{
                readOnly: true,
                disableUnderline: false, // underline ON
              }}
              value={PatientDobs || ""}
            />
          </Grid> */}
          <Grid item xs={12} md={12}>
            <Typography sx={{ lineHeight: 2 }}>
              I,
              <TextField
                variant="standard"
                size="small"
                sx={{
                  width: 200,
                  mx: 1,
                  verticalAlign: "middle",
                }}
                value={PatientName}
              />
              , make this statement and General Affidavit upon oath and
              affirmation of belief and personal knowledge that the following
              matters, facts, and things set forth are true and correct to the
              best of my knowledge. I have been prescribed the nasal CPAP to
              manage my sleep-related breathing disorder (apnea), and it has
              been advised that it is the GOLD STANDARD OF CHOICE for treatment
              of Obstructive Sleep Apnea.
            </Typography>
          </Grid>
        </Grid>

        {/* CPAP Intolerance Reasons */}
        <Grid
          container
          spacing={3}
          sx={{ m: 2, p: 2, backgroundColor: "#e8f4fd", borderRadius: 2 }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h6"
              fontWeight="bold"
              gutterBottom
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                width: "100%",
                color: "#000", // black color
                textDecoration: "underline", // underline
              }}
            >
              {/* I have attempted to use a CPAP device to manage my sleep-related breathing disorder and find it intolerable to use on a regular basis for the following reason(s): */}
              Attempted CPAP therapy has been made. It is intolerable to use on
              a regular basis for the following reason(s):
            </Typography>
          </Grid>

          {/* CPAP Intolerance Checkboxes */}
          {[
            {
              name: "hasAttemptedCPAPTherapy",
              label: "Attempted CPAP therapy has been made. It is intolerable to use on a regular",
            },
               {
              name: "basicFollowingReason",
              label: "basis for the following reason(s):",
            },
            {
              name: "claustrophobiaAnxiety",
              label: "Severe Claustrophobia or anxiety with CPAP mask",
            },

            {
              name: "pressureIntolerance",
              label: "Inability to tolerate pressure despite adjustments",
            },
            { name: "insomnia", label: "Persistent insomnia due to CPAP use" },
            {
              name: "nonAdherence",
              label: "Removes mask during sleep / non-adherence",
            },
            {
              name: "chronicNasalObstruction",
              label:
                "Chronic nasal obstruction (deviated septum, rhinitis, etc.)",
            },
            {
              name: "sinusComplications",
              label: "Recurrent sinus infections or ENT complications",
            },
            {
              name: "skinIssues",
              label:
                "Skin breakdown, Skin irritation, ulcers, or dermatitis from mask",
            },
            {
              name: "aerophagia",
              label: "Aerophagia (bloating, discomfort, GERD exacerbation)",
            },
            {
              name: "cognitiveImpairment",
              label: "Neurologic/cognitive impairment affecting compliance",
            },
            {
              name: "cpapIneffective",
              label: "CPAP ineffective despite adequate trial",
            },
          ].map((item) => (
            <Grid item xs={12} key={item.name}>
              <Controller
                name={item.name}
                control={control}
                render={({ field }) => (
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={field.value || false}
                      onClick={(e) => field.onChange(!field.value)}
                      style={{ marginRight: "10px", transform: "scale(1.2)" }}
                    />
                    <Typography variant="body1">{item.label}</Typography>
                  </label>
                )}
              />
            </Grid>
          ))}

          {/* Other CPAP Reason */}
          <Grid item xs={10}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Typography
                variant="body1"
                fontWeight="medium"
                sx={{ whiteSpace: "nowrap" }}
              >
                Other (please specify):
              </Typography>

              <Controller
                name="other_CPAP"
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    fullWidth
                    variant="standard"
                    InputProps={{
                      disableUnderline: false,
                    }}
                    {...field}
                  />
                )}
              />
            </div>
          </Grid>
        </Grid>

        {/* Preference for Oral Appliance */}
        <Grid
          container
          spacing={3}
          sx={{ m: 2, p: 2, backgroundColor: "#f8f9fa", borderRadius: 2 }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h6"
              fontWeight="bold"
              gutterBottom
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                width: "100%",
                color: "#000", // black color
                textDecoration: "underline", // underline
              }}
            >
              {/* I have not attempted to use a CPAP device and would prefer to use an oral appliance for the following reason(s):
               */}
              No attempt to use a CPAP device has been made. Oral Appliance
              should be used for the following reason(s):
            </Typography>
          </Grid>

          {/* No CPAP Checkboxes */}
          {[
            {
              name: "panicDisorder",
              label:
                "Claustrophobia or panic disorder preventing use of facial mask (documented panic attacks)",
            },
            {
              name: "craniofacialAbnormality",
              label:
                "Craniofacial abnormality or facial structure preventing proper CPAP mask seal",
            },
            {
              name: "severeNasalObstruction",
              label:
                "Severe nasal obstruction (e.g., deviated septum, polyps) not correctable or patient not surgical candidate",
            },
            {
              name: "latexAllergy_NoCPAP_New",
              label:
                "Allergic to latex (e.g. dermatitis, skin fragility) preventing mask use",
            },
            {
              name: "neurologicImpairment",
              label:
                "Neurologic or cognitive impairment preventing safe CPAP use(Dementia, etc)",
            },
            {
              name: "claustrophobia_NoCPAP_New",
              label: "High aspiration risk or inability to protect airway",
            },
            {
              name: "priorDocumentedIntolerance",
              label:
                "Prior documented intolerance to similar mask-based therapies",
            },
          ].map((item) => (
            <Grid item xs={12} key={item.name}>
              <Controller
                name={item.name}
                control={control}
                render={({ field }) => (
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={field.value || false}
                      onClick={(e) => field.onChange(!field.value)}
                      style={{ marginRight: "10px", transform: "scale(1.2)" }}
                    />
                    <Typography variant="body1">{item.label}</Typography>
                  </label>
                )}
              />
            </Grid>
          ))}

          {/* Other No CPAP Reason */}
          <Grid item xs={10}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Typography
                variant="body1"
                fontWeight="medium"
                sx={{ whiteSpace: "nowrap" }}
              >
                Other (please specify):
              </Typography>

              <Controller
                name="other_NoCPAP"
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    InputProps={{
                      disableUnderline: false,
                    }}
                    fullWidth
                    variant="standard"
                    {...field}
                  />
                )}
              />
            </div>
          </Grid>
        </Grid>

        {/* Treatment Preference Statement */}
        <Grid
          container
          spacing={3}
          sx={{ m: 2, p: 2, backgroundColor: "#e8f4fd", borderRadius: 2 }}
        >
          <Grid item xs={12}>
            <Typography
              variant="h6"
              fontWeight="bold"
              color="primary"
              gutterBottom
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                width: "100%",
                color: "#000", // black color
                textDecoration: "underline", // underline
              }}
            >
              {/* Because of my inability to use a CPAP device, I wish to have an alternative method of treatment. I would like to try an oral appliance in an attempt to control my snoring and obstructive sleep apnea. */}
              Because of the inability to use a CPAP device, an alternative
              method of treatment is needed.
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          sx={{ m: 2, p: 2, backgroundColor: "#f8f9fa", borderRadius: 2 }}
        >
          <Grid item xs={12} >
            <Typography sx={{ lineHeight: 2 }}>
              By signing this consent form, I acknowledge that I have been made
              aware of reasonable alternatives to MAD therapy for Obstructive
              Sleep Apnea including, but not limited to: tracheotomy; CPAP; oral
              or pharyngeal surgery; positional sleep therapy; weight loss and
              exercise. Additionally, I am aware that more than one treatment
              may be necessary for the best results.
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          sx={{ m: 2, p: 2, backgroundColor: "#f8f9fa", borderRadius: 2 }}
        >
          {/* Patient Signature */}

          <Grid item xs={12} md={8}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Typography
                variant="body1"
                fontWeight="medium"
                sx={{ whiteSpace: "nowrap" }}
              >
                Patient Signature:
              </Typography>
              <Controller
                name="patientSignature"
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    fullWidth
                    variant="standard"
                    {...field}
                  />
                )}
              />
            </div>
          </Grid>

          {/* Date */}
          <Grid item xs={12} md={4}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Typography
                variant="body1"
                fontWeight="medium"
                sx={{ whiteSpace: "nowrap" }}
              >
                Date:
              </Typography>

              <Controller
                name="signatureDate"
                control={control}
                render={({ field }) => (
                  <TextField
                    type="date"
                    size="small"
                    fullWidth
                    variant="standard"
                    InputLabelProps={{ shrink: true }}
                    {...field}
                    value={signatureDate || ""}
                    onChange={(e) => {
                      field.onChange(e.target.value);
                      setSignatureDate(e.target.value);
                    }}
                  />
                )}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Typography
                variant="body1"
                fontWeight="medium"
                sx={{ whiteSpace: "nowrap" }}
              >
                Physician Name:
              </Typography>
              <Controller
                name="physicianName"
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    fullWidth
                    variant="standard"
                    {...field}
                  />
                )}
              />
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Typography
                variant="body1"
                fontWeight="medium"
                sx={{ whiteSpace: "nowrap" }}
              >
                Patient Name:
              </Typography>
              <TextField
                size="small"
                fullWidth
                variant="standard"
                value={PatientName || ""}
              />
            </div>
          </Grid>

          <Grid item xs={12} md={8}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Typography
                variant="body1"
                fontWeight="medium"
                sx={{ whiteSpace: "nowrap" }}
              >
                Physician Signature:
              </Typography>
              <Controller
                name="physicianSignature"
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    fullWidth
                    variant="standard"
                    {...field}
                  />
                )}
              />
            </div>
          </Grid>

          {/* Date */}
          <Grid item xs={12} md={4}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Typography
                variant="body1"
                fontWeight="medium"
                sx={{ whiteSpace: "nowrap" }}
              >
                Date:
              </Typography>

              <Controller
                name="physicianDate"
                control={control}
                render={({ field }) => (
                  <TextField
                    type="date"
                    size="small"
                    fullWidth
                    variant="standard"
                    InputLabelProps={{ shrink: true }}
                    {...field}
                    value={physicianDate || ""}
                    onChange={(e) => {
                      field.onChange(e.target.value);
                      setphysicianDate(e.target.value);
                    }}
                  />
                )}
              />
            </div>
          </Grid>
        </Grid>

        {/* Submit Button */}
        {props.callingFrom == "PatientQuestionares" && (

        <Grid container justifyContent="flex-end" sx={{ mt: 4 }}>
          <Button
            type="submit"
            variant="contained"
            disabled={submitting}
            sx={{
              backgroundColor: "#A574FD",
              color: "white",
              minWidth: 120,
              height: 40,
              "&:hover": {
                backgroundColor: "#8A5CE6",
              },
            }}
          >
            {submitting ? "Saving..." : "Save"}
          </Button>
        </Grid>
        )}
      </form>
      </Grid>
    </Container>
  );
};

export default AffidavitForm;
